import React from 'react';
import { ToggleButton, ToggleButtonGroup } from '@mui/material';
import LightModeIcon from '@mui/icons-material/LightMode';
import DarkModeIcon from '@mui/icons-material/DarkMode';
import SettingsBrightnessIcon from '@mui/icons-material/SettingsBrightness';
import { useThemeMode } from '../themeMode';

const labels = {
  en: { group: 'Appearance', system: 'System', light: 'Light', dark: 'Dark' },
  fr: { group: 'Apparence', system: 'Système', light: 'Clair', dark: 'Sombre' },
};

export const appearanceToggleSx = {
  display: 'grid',
  gridTemplateColumns: 'repeat(3, minmax(0, 1fr))',
  gap: { xs: 0.5, sm: 1 },
  width: '100%',
  maxWidth: '100%',
  minWidth: 0,
  '& .MuiToggleButton-root': {
    border: '1px solid var(--cc-border)',
    borderRadius: '8px !important',
    boxSizing: 'border-box',
    minWidth: 0,
    width: '100%',
    gap: { xs: 0.5, sm: 1 },
    padding: { xs: '8px 4px', sm: '10px 8px' },
    flexDirection: { xs: 'column', sm: 'row' },
    fontSize: { xs: '0.8125rem', sm: '0.875rem' },
    lineHeight: 1.2,
    textTransform: 'none',
    fontWeight: 600,
    color: 'var(--cc-text-soft)',
    '& .MuiSvgIcon-root': {
      flexShrink: 0,
    },
    '&.Mui-selected': {
      backgroundColor: 'var(--cc-accent-soft)',
      borderColor: 'var(--cc-accent)',
      color: 'var(--cc-accent-dark)',
      '&:hover': {
        backgroundColor: 'var(--cc-accent-soft)',
      },
    },
  },
};

// Extracted from ProfilePage so the styleguide gallery can render the real
// control rather than a copy of its markup.
export default function AppearanceToggle({ isFrench = false, onChange }) {
  const { themeMode, setThemeMode } = useThemeMode();
  const t = isFrench ? labels.fr : labels.en;

  const handleChange = (event, newValue) => {
    // ToggleButtonGroup reports null when the active button is clicked again;
    // keeping the current mode avoids an unset appearance.
    if (newValue === null) return;
    setThemeMode(newValue);
    if (onChange) onChange(newValue);
  };

  const options = [
    ['system', t.system, <SettingsBrightnessIcon fontSize="small" />],
    ['light', t.light, <LightModeIcon fontSize="small" />],
    ['dark', t.dark, <DarkModeIcon fontSize="small" />],
  ];

  return (
    <ToggleButtonGroup
      value={themeMode}
      exclusive
      onChange={handleChange}
      aria-label={t.group}
      sx={appearanceToggleSx}
    >
      {options.map(([value, label, icon]) => (
        <ToggleButton key={value} value={value} aria-label={label}>
          {icon}
          {label}
        </ToggleButton>
      ))}
    </ToggleButtonGroup>
  );
}
